var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /~/core-js/library/modules/_html.js
// module id = RPLV
// module chunks = 0